import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PCacheable } from 'ts-cacheable';
import { environment } from '../../environments/environment';
import { TownDto } from '../models/town.dto';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class TownService {
  constructor(private readonly http: HttpClient, private readonly api: ApiService) {}

  public findByText(text: string): Observable<TownDto[]> {
    if (text && text !== '') {
      const url: string = environment.api.towns + '?q=' + text;
      return this.http.get<TownDto[]>(url);
    }
    return of([]);
  }

  @PCacheable()
  public async findMetropoleTowns(): Promise<TownDto[]> {
    return this.api.get<TownDto[]>(environment.api.towns + '/metropole');
  }
}
